import { Component, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { RouterPathService } from "../../../../core/common/variables/router-path.service";
import { InverterPlanGetData } from '../../../common/api/InverterPlanGet';
import { SC_Input } from '../../../common/input/SC_Input';
import ColorLib from '../../../common/lib/ColorLib';
import { InverterSetupBase } from '../../../common/lib/InverterSetupBase';
import { GlobalFunctionService } from '../../../common/services/global-function.service';
import { Global } from "../../../common/utilities/global";
import { TranslateService } from "../../../common/variables/translate-service";
import { SearchInverterService } from '../search-inverter/search-inverter-service';
import { AddInverterComponent } from "./add-inverter/add-inverter.component";
declare var randomColor: any;

@Component({
  selector: 'sen-app-customize',
  templateUrl: './customize.component.html',
  styleUrls: ['./customize.component.scss']
})
export class CustomizeComponent implements OnInit {
  prevPath: string;
  nextPath: string;
  inverterCom$: Observable<any>;
  allInverters$: Observable<any[]>;
  allInvertersUnSubscribe: Subscription;
  allInvertersList: any[] = [];
  selectedInverterCombo: any = [];
  selectedSubGen: number = NaN;
  selectedSubGenMPPT: any = {};
  selectedSubGenMPPTInd: number;
  interConnectedPanels: number;
  interConnectedPanelsKW: number;
  totalKW: number;
  displayedColumns: string[] = ['name', 'count', 'panels'];
  dataSource = new MatTableDataSource();
  selectedInverter: InverterPlanGetData = SC_Input.sInverter;
  convertToLocalNumber: any = Global.convertToLocalNumber;

  constructor(private routerPath: RouterPathService,
    public dialog: MatDialog,
    private store: Store<any>,
    private route: ActivatedRoute,
    private router: Router,
    private _snackBar: MatSnackBar,
    public SIService: SearchInverterService,
    public globalF: GlobalFunctionService,
    public translate: TranslateService) {
    this.prevPath = `../${this.routerPath.IPSearchInverterString}`;
    this.nextPath = `../${this.routerPath.IPStringingString}`;
    this.inverterCom$ = this.store.select(state => { return state.appData.inverterCombo });
    this.allInverters$ = this.store.select(state => { return state.appData.allInverters });
    this.allInvertersUnSubscribe = this.allInverters$.subscribe(data => {
      this.allInvertersList = data;
    })
  }

  ngOnInit(): void {
    this.SIService.getAllInverter();
    this.SIService.selectPanel(SC_Input.sPanel);
    this.SIService.setCosPhi(SC_Input.sInverter.cosPhi);
    this.SIService.setFactor(SC_Input.sInverter.dimensionMin / 100, SC_Input.sInverter.dimensionMax / 100);
    if (SC_Input.sInverter.subGenerators) {
      this.selectedInverterCombo = _.cloneDeep(SC_Input.sInverter.subGenerators);
    }
    this.setInterConnectedPanelsCount();
    this.totalKW = Global.getKW(this.selectedInverter.panelCount, SC_Input.sPanel.Pdc);
  }

  ngOnDestroy() {
    this.selectedInverterCombo.forEach((g: any) => {
      g.panelCount = this.getTotalPanels(g.mppt);
    });
    if (SC_Input.sInverter.subGenerators && SC_Input.sInverter.subGenerators.length != this.selectedInverterCombo.length) {
      this.resetString();
    } else {
      let equal: boolean = true;
      if (SC_Input.sInverter.subGenerators)
      this.selectedInverterCombo.forEach((g: any, ind: number) => {
        if (!_.isEqual(g.mppt, SC_Input.sInverter.subGenerators[ind].mppt)) {
          equal = false;
        }
      });
      if (!equal) {
        this.resetString();
      }
    }
    if (!SC_Input.sInverter.subGenerators && this.selectedInverterCombo.length > 0) {
      this.resetString();
    }
    SC_Input.sInverter.subGenerators = this.selectedInverterCombo;
    this.allInvertersUnSubscribe.unsubscribe();
  }

  resetString() {
    this.selectedInverterCombo.forEach((g: any, ind: number) => {
      let shade = 0.0;
      let stringCount = 0;
      let labelCount = 1;
      g.strings = [];
      for (let tracker of g.mppt) {
        stringCount += tracker.stringCount;
      }
      let shadeStep = ColorLib.calculateShadeStep(stringCount);
      g.mppt.forEach((m: any) => {
        for (let i = 0; i < m.stringCount; i++) {
          let stringColor = ColorLib.shadeColor(g.color, shade);
          if (labelCount % 4 == 0) { // at every 4th step it reset color to orignal since the color dilution makes the color to white
            shade = 0.0;
          } else {
            shade += shadeStep;
          }
          g.strings.push({
            name: `${this.translate.getLng('INV_STRING')} ${ind + 1}.${labelCount}`,
            color: stringColor,
            panelCount: m.panelCountPerString,
            nodes: null
          });
          ++labelCount;
        }
      });
    });
  }

  addInverter() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `${this.translate.getLng('ADD_PAR_GEN')}`,
      buttons: {
        add: this.translate.getLng('ADD'),
        cancel: this.translate.getLng('CANCEL')
      }
    };
    dialogConfig.disableClose = true;
    dialogConfig.width = '400px';
    dialogConfig.position = { top: '10vh' }
    let dialogRef = this.dialog.open(AddInverterComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result: any[]) => {
      dialogRef.close();
      if (result) {
        let setups: InverterSetupBase[] = [];
        result.forEach((g: any) => {
          for (let i = 0; i < g.times; i++) {
            setups.push(new InverterSetupBase(g.inverter.maxPanel, g.inverter.id, g.inverter.name));
          }
        });
        this.selectedSubGenMPPTInd = NaN;
        this.selectedSubGenMPPT = {};
        this.dataSource = new MatTableDataSource();
        let setupsMppt = this.SIService.generateSetupCombination(setups);
        let subGen = this.SIService.addMpptToSetups(setupsMppt, this.selectedInverterCombo.length);
        this.selectedInverterCombo = subGen.concat(this.selectedInverterCombo);
        this.setInterConnectedPanelsCount();
      }
    });
  }

  setInterConnectedPanelsCount() {
    this.interConnectedPanels = 0;
    this.selectedInverterCombo.forEach((i: any) => {
      this.interConnectedPanels += this.getTotalPanels(i.mppt);
    });
    this.interConnectedPanelsKW = Global.getKW(this.interConnectedPanels, SC_Input.sPanel.Pdc);
  }

  getTotalPanels(mppt: any) {
    let t: number = 0;
    mppt.forEach((i: any) => {
      if (i.stringCount) {
        t += i.stringCount * i.panelCountPerString;
      } else {
        t += i.panelCountPerString;
      }
    });
    return t;
  }

  getInverterName(s: any) {
    if (s.inverterName) {
      return s.inverterName
    } else {
      return _.find(this.allInvertersList, { id: s.inverterID }).name;
    }
  }

  showMPPT(inx: number, subGen: any) {
    this.selectedSubGenMPPT = subGen;
    this.selectedSubGenMPPTInd = inx;
    this.dataSource = new MatTableDataSource(subGen.mppt);
  }

  triggerConfirmation() {
    let dialogRef = this.globalF.openConfirmationBox('DELETE_INVERTER_QUE');
    dialogRef.afterClosed().subscribe((result: boolean) => {
      dialogRef.close();
      if (result) {
        if (this.selectedInverterCombo.length > 1) {
          this.selectedInverterCombo.splice(this.selectedSubGen, 1);
        } else {
          this.selectedInverterCombo = [];
        }

        this.setInterConnectedPanelsCount();
        this.selectedSubGen = NaN;
        this.dataSource = new MatTableDataSource();
        this.selectedSubGenMPPT = null;
      }
    });
  }

  selectSubGen(ind: number, event: MatCheckboxChange) {
    if (ind == this.selectedSubGen) {
      this.selectedSubGen = NaN;
    } else {
      this.selectedSubGen = ind;
    }
  }



  goToNext() {
    if (this.interConnectedPanels != this.selectedInverter.panelCount) {
      // TODO: Improve placeholder
      let message = this.translate.getLng('CUSTOM_PANEL_COUNT_MESSAGE').replace('{COMBINED_PANEL}', this.interConnectedPanels).replace('{ALL_PANEL_COUNT}', this.selectedInverter.panelCount);
      this._snackBar.open(message);
      return;
    }
    this.router.navigate([this.nextPath], { relativeTo: this.route });
  }
}
``
